export const teamNameMap = new Map([
  // English Premier league
  ['ARS', 'Arsenal'],
  ['CHE', 'Chelsea'],
  ['CRY', 'C Palace'],
  ['EVE', 'Everton'],
  ['IPS', 'Ipswich Town FC'],
  ['LEI', 'Leicester City FC'],
  ['LIV', 'Liverpool'],
  ['LUT', 'Luton'],
  ['MCI', 'Man City'],
  ['MUN', 'Man Utd'],
  ['NEW', 'Newcastle'],
  ['AVA', 'Aston Villa'],
  ['BRH', 'Brighton'],
  ['SOU', 'Southampton FC'],
  ['TOT', 'Tottenham'],
  ['WHU', 'West Ham'],
  ['WLV', 'Wolves'],
  ['FUL', 'Fulham'],
  ['BRE', 'Brentford'],
  ['NTG', 'Nottingham Forest'],
  ['BOU', 'AFC Bournemouth'],
  // English Championship
  ['BBR', 'Blackburn Rovers FC'],
  ['BRC', 'Birmingham City FC'],
  ['BSC', 'Bristol City FC'],
  ['BUR', 'Burnley'],
  ['CDF', 'Cardiff City FC'],
  ['CVC', 'Coventry City FC'],
  ['HDD', 'Huddersfield Town AFC'],
  ['HUL', 'Hull City AFC'],
  ['LEE', 'Leeds United FC'],
  ['MID', 'Boro'],
  ['MLW', 'Millwall FC'],
  ['NOR', 'Norwich City FC'],
  ['PLA', 'Plymouth Argyle FC'],
  ['PNE', 'Preston North End FC'],
  ['QPR', 'Queens Park Rangers FC'],
  ['RTU', 'Rotherham United FC'],
  ['SHF', 'Sheffield Wednesday FC'],
  ['STK', 'Stoke City FC'],
  ['SUN', 'Sunderland AFC'],
  ['SWA', 'Swansea City AFC'],
  ['WAT', 'Watford FC'],
  ['WBA', 'West Bromwich Albion FC'],
  // International teams
  ['ALB', 'Albania'],
  ['GEO', 'Georgia'],
  ['ROM', 'Romania'],
  ['SVN', 'Slovenia'],
  ['NRW', 'Norway'],
  ['GER', 'Germany'],
  ['FRA', 'France'],
  ['POR', 'Portugal'],
  ['HUN', 'Hungary'],
  ['SWE', 'Sweden'],
  ['ESP', 'Spain'],
  ['SVK', 'Slovakia'],
  ['POL', 'Poland'],
  ['CZE', 'Czechia'],
  ['SCO', 'Scotland'],
  ['UKR', 'Ukraine'],
  ['NLD', 'Netherlands'],
  ['MKD', 'North Macedonia'],
  ['AUT', 'Austria'],
  ['CRO', 'Croatia'],
  ['ENG', 'England'],
  ['RUS', 'Russia'],
  ['BEL', 'Belgium'],
  ['FIN', 'Finland'],
  ['DNK', 'Denmark'],
  ['SWI', 'Switzerland'],
  ['WAL', 'Wales'],
  ['ITA', 'Italy'],
  ['TUR', 'Türkiye'],
  ['NIR', 'Northern Ireland'],
  ['ICE', 'Iceland'],
  ['ARG', 'Argentina'],
  ['AUS', 'Australia'],
  ['BRA', 'Brazil'],
  ['CAN', 'Canada'],
  ['CMR', 'Cameroon'],
  ['CRI', 'Costa Rica'],
  ['ECU', 'Ecuador'],
  ['GHA', 'Ghana'],
  ['IRN', 'Iran'],
  ['JPN', 'Japan'],
  ['KOR', 'Korea Republic'],
  ['MAR', 'Morocco'],
  ['MEX', 'Mexico'],
  ['QAT', 'Qatar'],
  ['KSA', 'Saudi Arabia'],
  ['SEN', 'Senegal'],
  ['SRB', 'Serbia'],
  ['TUN', 'Tunisia'],
  ['URY', 'Uruguay'],
  ['USA', 'USA'],
  ['CHN', 'China'],
  ['COL', 'Colombia'],
  ['HTI', 'Haiti'],
  ['IRL', 'Ireland'],
  ['JAM', 'Jamaica'],
  ['NGA', 'Nigeria'],
  ['NZL', 'New Zealand'],
  ['PAN', 'Panama'],
  ['PHL', 'Philippines'],
  ['VNM', 'Vietnam'],
  ['ZAF', 'South Africa'],
  ['ZMB', 'Zambia'],
  // Eredivisie (Dutch League)
  ['AJA', 'Ajax Amsterdam'],
  ['AZA', 'AZ Alkmaar'],
  ['CAM', 'Cambuur'],
  ['FEY', 'Feyenoord'],
  ['FST', 'Fortuna Sittard'],
  ['GAE', 'Go Ahead Eagles'],
  ['GRO', 'FC Groningen'],
  ['HEA', 'Heracles Almelo'],
  ['HEE', 'SC Heerenveen'],
  ['NEC', 'NEC Nijmegen'],
  ['PEC', 'PEC Zwolle'],
  ['PSV', 'PSV Eindhoven'],
  ['SPR', 'Sparta Rotterdam'],
  ['TWE', 'FC Twente'],
  ['UTR', 'FC Utrecht'],
  ['VIT', 'Vitesse Arnhem'],
  ['WAA', 'RKC Waalwijk'],
  ['WIL', 'Willem II'],
  ['VLN', 'FC Volendam'],
  ['EXC', 'SBV Excelsior'],
  ['EMM', 'Emmen'],
  ['ALM', 'Almere City'],
  ['SHU', 'Sheffield United FC'],
  ['NBR', 'NAC Breda'],
  //Bulgarian League
  ['BG-ARD', 'Arda Kardzhali'],
  ['BG-BSZ', 'Beroe'],
  ['BG-BOT', 'Botev Plovdiv'],
  ['BG-BTV', 'Botev Vratsa'],
  ['BG-CMV', 'Cherno More Varna'],
  ['BG-CSK', 'CSKA 1948 Sofia'],
  ['BG-HEB', 'Hebar'],
  ['BG-KMG', 'Krumovgrad'],
  ['BG-LKS', 'Levski Sofia'],
  ['BG-LMP', 'Lokomotiv Plovdiv'],
  ['BG-LGR', 'Ludogorets Razgrad'],
  ['BG-CSS', 'PFC CSKA-Sofia'],
  ['BG-LMS', 'PFC Lokomotiv Sofia 1929'],
  ['BG-SFA', 'Septemvri Sofia'],
  ['BG-SSF', 'Slavia Sofia'],
  ['BG-SPT', 'Spartak Varna']
]);

/**
 * A map that can be used for a client to override the team code we use for a given team.
 */
export const teamCodeMap = new Map([
  // Eredivisie (Dutch League)
  ['AZA', 'AZ'], // AZ Alkmaar
  ['FST', 'FOR'], // Fortuna Sittard
  ['HEA', 'HER'], // Heracles
  ['SPR', 'SPA'], // Sparta Rotterdam
  ['WAA', 'RKC'], // RKC Waalwijk
  //Bulgarian League
  ['BG-ARD', 'АРДА'], // Arda Kardzhali
  ['BG-BSZ', 'БЕР'], // Beroe
  ['BG-BOT', 'БОТП'], // Botev Plovdiv
  ['BG-BTV', 'БОТВ'], // Botev Vratsa
  ['BG-CMV', 'ЧМОР'], // Cherno More Varna
  ['BG-CSK', 'ЦС48'], // CSKA 1948 Sofia
  ['BG-HEB', 'ХЕБ'], // Hebar
  ['BG-KMG', 'КРУ'], // Krumovgrad
  ['BG-LKS', 'ЛЕВ'], // Levski Sofia
  ['BG-LMP', 'ЛОКП'], // Lokomotiv Plovdiv
  ['BG-LGR', 'ЛУДО'], // Ludogorets Razgrad
  ['BG-CSS', 'ЦСКА'], // PFC CSKA-Sofia
  ['BG-LMS', 'ЛОКС'], // PFC Lokomotiv Sofia 1929
  ['BG-SFA', 'СЕПТ'], // Septemvri Sofia
  ['BG-SSF', 'СЛА'], // Slavia Sofia
  ['BG-SPT', 'СПВ'], // Spartak Varna
  // Premier League
  ['NTG', 'FOR'], // Nottingham Forest
  ['WLV', 'WOL'], // Wolves
  ['BRH', 'BHA'], // Brighton
  ['AVA', 'AVL'] // Aston Villa
]);
